import React, { Component } from 'react';
import {Bar, Line, Pie,Radar} from 'react-chartjs-2';

class Charts extends Component {
    state = {
       
        chartData: {
            labels: this.props.chartLabels,
            
            datasets: [
                {
                    label: "kWh",
                    fill: true,
                   borderColor: "#000000",
               
                   pointHitRadius: 10,
                   backgroundColor: "rgb(226, 132, 50, 0.68)",
                   barThickness: 10,
                    data: this.props.data
                    
                }
            ]
        }   
    }

   chartClick = (e) => {
    let activeBars = this.refs.myChart.getBarsAtEvent(e);
    console.log("anything");
   }

    render() { 
        return ( 
            <Bar
            ref="myChart"
            getElementsAtEvent={(elems) => {
                //get bottom label'
                if(elems["0"] != undefined){
                    
                    var label = elems["0"]._model.label
                    this.props.fp_get_selected_bar(label)
                }
            }}
            data= {this.state.chartData}
            width = {800}
            height = {300}
            options={{
                title: {
                    display: true,
                    text: this.props.title
                },
                legend: {
                    display: false
                },
                animation: {
                    easing: 'easeOutElastic',
                    duration: '1500'
                },
                tooltips:{
                    bodyFontStyle: 'bold',
                    bodyFontFamily: 'Lato',
                    xPadding: 40,
                    yPadding: 20,
                    backgroundColor: '#001e61',
                    
                },
                
                labels: {
                    bodyFontFamily: 'Open Sans',
                    bodyFontStyle: 'Bold'
                },
                maintainAspectRatio: true,
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true 
                        },
                        gridLines:{
                            display: true
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'kWh'
                        }
                    }],
                    xAxes: [{
                        
                        gridLines:{
                            display: false
                        },
                        barPercentage: 1
                    }]
                },

            }}
            />
        )
    }
}

export default Charts;





// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/MonitoringJumbo/Charts.jsx